import { render } from "./ModalViewEditItemApplied.vue?vue&type=template&id=ddee72c8&scoped=true"
import script from "./ModalViewEditItemApplied.vue?vue&type=script&lang=js"
export * from "./ModalViewEditItemApplied.vue?vue&type=script&lang=js"

import "./ModalViewEditItemApplied.vue?vue&type=style&index=0&id=ddee72c8&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddee72c8"]])

export default __exports__